module.exports = __webpack_public_path__ + "static/img/MS_H5.00ff503.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MS_H5.png
// module id = aVx8
// module chunks = 34